import React, { useState, useEffect, useRef  } from 'react';
import { TrendingUp, CheckCircle, Clock } from 'lucide-react';
import "../Admin/css/profile.css";
import "../Admin/css/layout.css";
import Sidebar from "./Sidebar";
import { secureStorage } from '../utils/secureStorage';
import Header from './Header';
import { TfiWorld } from "react-icons/tfi";
import { BsBook } from "react-icons/bs";
import { LuUserRoundPlus } from "react-icons/lu";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { LuServerCog } from "react-icons/lu";
import { RiContactsBook3Line } from "react-icons/ri";
import { FiPhoneCall } from "react-icons/fi";
import { IoMailOpenOutline } from "react-icons/io5";
import { SlCalender } from "react-icons/sl";
import { getScholarProfile } from '../service/profileService';
import {getLastWorkStatus} from "../service/dashboardService.js";
import { useNavigate } from "react-router-dom";
import { uploadScholarProfile , deleteScholarProfile } from "../service/profileImageService.js";
import { Camera, Trash2 } from "lucide-react";  

  const Profile = () => {
  const navigate = useNavigate();
  //const [loading, setLoading] = useState(true);
  //const [profileImage, setProfileImage] = useState(null);
  //const [hoverImage, setHoverImage] = useState(false);
  //const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const scholar = secureStorage.getScholar();
  // const { data: scholarData } = useScholar();
  // console.log("scholar data", scholarData);
  //const [workProgress] = useState(65);
  const scholarId = scholar?.id;
  const [workStatus, setWorkStatus] = useState(null);
  const [domain, setDomain] = useState("");
  const [journalIndex, setJournalIndex] = useState("");
  const [techExpert, setTechExpert] = useState("");
  const [bdaName, setBdaName] = useState("");
  const [staff_contact, setStaffContact] = useState("");
  const [bdaContact, setBdaContact] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const fileInputRef = useRef(null);
const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [notification, setNotification] = useState({
  show: false,
  message: "",
  type: "success",
});

const showNotification = (message, type = "success") => {

  setNotification({
    show: true,
    message,
    type,
  });

  setTimeout(() => {
    setNotification({
      show: false,
      message: "",
      type: "success",
    });
  }, 3000);
};
 
const uploadProfileImage = async (file) => {
  try {
    const response = await uploadScholarProfile(
      scholar.id,
      file,
      1
    );

    console.log("Upload Response:", response);

    // API image path
    const imagePath    =
      response?.data?.scholar_profile ||
      response?.scholar_profile;

   if (imagePath) {

      // full URL if backend returns uploads/filename.png
     const fullImageUrl = imagePath.startsWith("http")
  ? imagePath
  : `http://scholarapi.seasense.in/${imagePath}`;
    


      setProfileImage(fullImageUrl);
    }
    showNotification(
  "Profile image uploaded successfully",
  "success"
);

    // refresh profile data
    //fetchScholarById(scholar.id);

  } catch (error) {
    console.error("Upload Error:", error);
    showNotification(
    "Image upload failed",
    "error"
  );
  }
  
};


const handleImageChange = async (e) => {
  const file = e.target.files[0];

  if (file) {
    // instant preview
    const reader = new FileReader();

    reader.onloadend = () => {
      setProfileImage(reader.result);
    };

    reader.readAsDataURL(file);

    // upload image
    await uploadProfileImage(file);
  }
};

 useEffect(() => {
  if (scholar?.id) {
    fetchScholarById(scholar.id);
  }
}, [scholar?.id]);


const fetchScholarById = async (id) => {
  try {
    setLoading(true);

    const response = await getScholarProfile(id);

    console.log("Scholar Data:", response.data);

    const scholarData  = response?.data?.data;
   const imagePath = scholarData?.scholar_profile;

if (imagePath) {
  setProfileImage(
    `http://scholarapi.seasense.in/${imagePath}`
  );
}

    setDomain(scholarData ?.domain_nm || "");
    setJournalIndex(scholarData?.journal_index?.journal_index || "");
    setTechExpert(scholarData?.tech_expert?.staff_name || "Not Assigned");
    setBdaName(scholarData?.bda?.bda_name || "Not Assigned");
    setStaffContact(scholarData?.tech_expert?.staff_contact || "Not Assigned");
    setBdaContact(scholarData?.bda?.bda_contact || "Not Assigned");
    
  } catch (error) {
    console.error("Error fetching scholar profile:", error);
  } finally {
    setLoading(false);
  }
};


const fetchLastWorkStatus = async () => {
  try {
    if (!scholarId) return;

    const res = await getLastWorkStatus(scholarId);
    console.log("Last Work Status Response:", res.data);
    const statusData = res.data?.data.status || {};
    console.log("Extracted Work Status Data:", statusData);

    setWorkStatus(statusData  );

  } catch (err) {
    console.error(
      "Work Status API Error:",
      err.response?.data || err.message
    );
  }
};


useEffect(() => {
  if (scholarId) {
  fetchLastWorkStatus();
  }
}, [scholarId]);



const handleRemoveImage = async () => {
  try {

    const response = await deleteScholarProfile(scholar.id);

    console.log("Delete Response:", response);

    setProfileImage(null);
     setShowDeletePopup(false);
     showNotification(
      "Profile image removed successfully",
      "success"
    );

    //fetchScholarById(scholar.id);

  } catch (error) {
    console.error(
      "Delete Image Error:",
      error.response?.data || error.message
    );
     setShowDeletePopup(false);

    showNotification(
      "Failed to remove profile image",
      "error"
    );
  }
};
  // const handleImageClick = () => {
  //   fileInputRef.current.click();
  // };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setProfileImage(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  useEffect(() => {
  const scholar = secureStorage.getScholar();

  if (!scholar) {
    navigate("/", { replace: true });
  }
}, [navigate]);

  if (loading) {
    return (
      <>
        <div className="layout">
          <Sidebar />
          <div className="main-area">
            <Header />
        <div className="modern-loader-container">
     <div className="modern-loader-card">
    <div className="modern-loader-animation">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <h3>Loading Profile</h3>
    <p>Please wait while we fetch your profile details...</p>
  </div>
</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="layout">
        <Sidebar />
        <div className="main-area">
          <Header />
          <div className="profile-container">

            <h2 className="profile-title">Profile Information</h2>
            <p className="profile-subtitle">
              Manage your personal and academic details
            </p>
            <div className="profile-grid">
              {/* LEFT CARD */}
              <div className="profile-card left">
              <div className="profile-top-section">
       <div className="profile-avatar-wrapper">

  {/* Profile Image */}
  <div
    className="profile-image-container"
    onClick={() => fileInputRef.current.click()}
    style={{ cursor: "pointer" }}
  >
    {profileImage ? (
      <img
        src={profileImage}
        alt="Profile"
        className="profile-image"
      />
    ) : (
      <div className="profile-avatar-modern">
        {scholar?.user_name?.charAt(0)?.toUpperCase() || "U"}
      </div>
    )}

    {/* Upload Icon */}
    <div className="upload-icon">
      <Camera size={18} />
    </div>

    {/* Remove Icon */}
    {profileImage && (
      <div
        className="remove-icon"
        onClick={(e) => {
          e.stopPropagation();
          setShowDeletePopup(true);
        }}
      >
        <Trash2 size={18} />
      </div>
    )}
  </div>

  <input
    type="file"
    accept="image/*"
    ref={fileInputRef}
    style={{ display: "none" }}
    onChange={handleImageChange}
  />
</div>
{notification.show && (
  <div className={`custom-notification ${notification.type}`}>
    
    <div className="notification-content">

      <div className="notification-icon">
        {notification.type === "success" ? "✓" : "⚠"}
      </div>

      <div>
        <h4>
          {notification.type === "success"
            ? "Success"
            : "Error"}
        </h4>

        <p>{notification.message}</p>
      </div>

    </div>
  </div>
)}
              <h3 className="profile-user-name">
                {scholar?.user_name}
              </h3>

              {/* <p className="profile-role">
                PhD Scholar
              </p> */}

              <span className="profile-id-badge">
                {scholar?.user_id}
              </span>

            </div>

            <div className="divider"></div>
            <div className="profile-alg">
              <h4>Personal Information</h4>

              <div className="profile-info">
                <IoMailOpenOutline  className="profile-icon" />
                <span>{scholar?.email}</span>
              </div>

              <div className="profile-info">
                <FiPhoneCall className="profile-icon" />
                <span>+91 {scholar?.contact}</span>
              </div>

              <div className="profile-info">
                <SlCalender  className="profile-icon" />
                <span>
                  {scholar?.reg_date
                    ? new Date(scholar.reg_date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : "N/A"}
                    (Registration date)
                </span>
              </div>
            </div>
          </div>
          {showDeletePopup && (
  <div className="delete-popup-overlay">
    <div className="delete-popup">
      <h3>Delete Profile Image</h3>
      <p>
        Are you sure you want to remove your profile image?
      </p>

      <div className="delete-popup-buttons">
        <button
          className="cancel-btn"
          onClick={() => setShowDeletePopup(false)}
        >
          Cancel
        </button>

        <button
          className="delete-btn"
          onClick={handleRemoveImage}
        >
          OK
        </button>
      </div>
    </div>
  </div>  
)}

              {/* RIGHT CARD */}
              <div className="profile-card right">
                <h3>Work Information</h3>
                <div className="info-grid">
                  {/* <div>
                    <label>Date of Registration</label>
                    <p><FaCalendarAlt /> {scholar?.reg_date ? new Date(scholar.reg_date).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric"
                    }) : 'N/A'}</p>
                  </div> */}
                  <div>
                    <label>Domain</label>
                    <p> <TfiWorld  className="profile-icons" />{domain}</p>
                  </div>

                  <div>
                    <label>Journal Index</label>
                    <p><BsBook  className="profile-icons" />{journalIndex}</p>
                  </div>
                  <div>
                    <label>Technical Expert</label>
                    <p> <LuUserRoundPlus  className="profile-icons" />{techExpert}</p>
                  </div>
                  <div>
                    <label>Technical Expert Contact</label>
                    <p><FiPhoneCall  className="profile-icons" />{staff_contact}</p>
                  </div>
                  <div>
                  <label>BDA Name</label>
                  <p><AiOutlineUsergroupAdd  className="profile-icons" />{bdaName}</p>
                  </div>
                  <div>
                    <label>BDA Contact</label>
                    <p><RiContactsBook3Line   className="profile-icons" />{bdaContact}</p>
                  </div>
                </div>
                <br></br>
                 <div>
                  <label>Work Description</label>
                  <p className="description">
                     <LuServerCog  className="profile-icons" />{scholar?.work_description}
                  </p>
                </div>
              <div className="divider"></div>
                <div className="progress-premium-card">
                  <div className="card-premium-header">
                    <TrendingUp size={20} className="trending-icon" />
                    <h3>Project Completion</h3>
                    <span className="progress-percentage-badge"> {workStatus || 0}%</span>
                  </div>
                  <div className="progress-premium-bar">
                    <div className="progress-premium-fill"  style={{ width: `${workStatus || 0}%` }}>
                      <div className="progress-premium-glow"></div>
                    </div>
                  </div>
                  <div className="progress-premium-stats">
                    <div className="progress-stat">
                      <CheckCircle size={14} style={{ color: "#000000" }} />
                      <span >Completed Tasks</span>
                      {/* <strong style={{ color: "#000000" }}>42/100</strong> */}
                    </div>
                    <div className="progress-stat">
                      <Clock size={14} />
                      <span>Remaining</span>
                      {/* <strong style={{ color: "#000000" }}>23</strong> */}
                    </div>
                  </div>
                </div>               
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;